import type {Values} from '@wix/devzai-utils-common';
import {evaluateFunction} from '@wix/devzai-utils-common';
import type {DoppeBusinessEntityReference} from './doppe-business-entity';
import {DoppeBusinessEntity} from './doppe-business-entity';

export const DoppeExternalFormProvider = {
    Hopp: 'hopp',
} as const;

export type DoppeExternalFormProvider = Values<typeof DoppeExternalFormProvider>;

export function doppeExternalFormProviderResolveBusinessEntityReference(
    externalFormProvider: DoppeExternalFormProvider,
    externalFormId: string
) {
    return evaluateFunction(() => {
        switch (externalFormProvider) {
            case DoppeExternalFormProvider.Hopp: {
                return {
                    businessEntity: DoppeBusinessEntity.HoppForm,
                    id: externalFormId
                } as DoppeBusinessEntityReference<typeof DoppeBusinessEntity.HoppForm>
            }
        }
    }) satisfies DoppeBusinessEntityReference
}
